/* eslint-disable @typescript-eslint/no-use-before-define */
import {
    Action,
    ActionReducerMap,
    createFeatureSelector,
    createSelector,
    StoreModule,
} from '@ngrx/store';
import {
    GeoBounds,
    GeoCoordinate,
} from '@polaris-customerweb/sharedcomponents.shared';
import type { StyleSpecification } from 'mapbox-gl';
import { MapAction, SetMapStyle } from './map.actions';

export interface MapState {
    isSidenavOpen: boolean;
    isRightSideNavOpen: boolean;
    mapStyle: StyleSpecification | null;
}

export interface MapExtents {
    bounds: GeoBounds;
    center: GeoCoordinate;
    zoom: number;
}

const reducerMap: ActionReducerMap<MapState> = {
    isRightSideNavOpen: isRightSideNavOpenReducer,
    isSidenavOpen: isSidenavOpenReducer,
    mapStyle: mapStyleReducer,
};

/* eslint-disable max-len */
export const selectMapState = createFeatureSelector<MapState>('mapState');

export const selectIsMapSidenavOpen = createSelector(
    selectMapState,
    (state) => state.isSidenavOpen
);

export const selectIsMapRightSidenavOpen = createSelector(
    selectMapState,
    (state) => state.isRightSideNavOpen
);

export const selectMapStyle = createSelector(
    selectMapState,
    (state) => state.mapStyle
);

/* eslint-enable max-len */

export const mapStoreModule = StoreModule.forFeature('mapState', reducerMap);

function isSidenavOpenReducer(state: boolean, action: Action) {
    switch (action.type) {
        case MapAction.closeMapSidenav:
            return false;
        case MapAction.openMapSidenav:
            return true;
        default:
            return state;
    }
}

function isRightSideNavOpenReducer(state: boolean, action: Action) {
    switch (action.type) {
        case MapAction.closeMapRightSidenav:
            return false;
        case MapAction.openMapRightSidenav:
            return true;
        default:
            return state;
    }
}

function mapStyleReducer(state = null, action: Action) {
    switch (action.type) {
        case MapAction.setMapStyle:
            return (action as SetMapStyle).style;
        default:
            return state;
    }
}
